// Servicio para subir INE a Firebase Storage (o simulado)
// Requiere que tengas configurado Firebase Storage en tu proyecto
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage'
import { auth } from './firebase'

export async function uploadINEImage(file, userId) {
  const storage = getStorage()
  const ext = file.name.split('.').pop()
  const storageRef = ref(storage, `kyc/${userId}/ine.${ext}`)
  const metadata = { contentType: file.type }
  await uploadBytes(storageRef, file, metadata)
  return await getDownloadURL(storageRef)
}
